import styled from "@emotion/styled";

interface MDSSpacerProps {
  flexGrow?: number;
}

export const MDSSpacer = styled.div<MDSSpacerProps>`
  flex: 1;
  flex-grow: ${({ flexGrow }) => flexGrow ?? 1};
`;
